export const quoteCheckoutURL = (quoteId, boilerId) => {
  const url = "/quote/checkout?quote=" + quoteId + "&boiler=" + boilerId
  return url
}
